// import ProductsListItem from './ProductsListItem';

function ProductsList() {
    return (
        <div className="mt-6 mx-5">
            <div className="products-list">
                <div className="mt-3 border border-[#EAEAEA] rounded-lg">
                    <div className="flex bg-[#F5F5F5] font-urbanist-regular font-semibold">
                        <h2 className="w-[29%] px-[10px] py-2 text-[14px] leading-6 text-[#666666] uppercase">Product</h2>
                        <h2 className="w-[11%] px-[10px] py-2 text-[14px] leading-6 text-[#666666]">Current Price</h2>
                        <h2 className="w-[11%] px-[10px] py-2 text-[14px] leading-6 text-[#666666]">Total Sales</h2>
                        <h2 className="w-[11%] px-[10px] py-2 text-[14px] leading-6 text-[#666666]">Total Orders</h2>
                        <h2 className="w-[11%] px-[10px] py-2 text-[14px] leading-6 text-[#666666]">Avg. Order Value</h2>
                        <h2 className="w-[11%] px-[10px] py-2 text-[14px] leading-6 text-[#666666]">Preferred Price</h2>
                        <h2 className="w-[9%] px-[10px] py-2 text-[14px] leading-6 text-[#666666]">Avg. Rating</h2>
                        <h2 className="w-[9%] px-[10px] py-2 text-[14px] leading-6 text-[#666666]">Actions</h2>
                    </div>

                    {/* <ProductsListItem 
                        id={'gwvhr3t7fgyuhwbew'}
                    /> */}
                </div>
            </div>
        </div>
    );
}

export default ProductsList;
